import http from 'plugins/axios';

export default {
  getAllCoin() {
    return http.get({
      url: '/la/admin/coin/all'
    });
  },
  getList(data) {
    return http.post({
      url: '/la/admin/property/search',
      data,
      dataType: 'form'
    });
  }
};
